export const modalIds = {
  confirm: 'confirm-modal',
  hostfullyAccountingEnrollment: 'hostfully-accounting-enrollment-modal',
};
